import { createCarouselSlice } from './createCarouselSlice'

/**
 * Redux slice for the "Opciones similares" (alternative products) carousel
 * shown on the product-detail page.
 * State shape and reducers come from `createCarouselSlice`.
 * @internal
 */
export const alternativeProductsSlice = createCarouselSlice(
  'alternativeProductsSlice',
)

export const {
  setItems: setAlternativeProductsItems,
  setStatus: setAlternativeProductsStatus,
} = alternativeProductsSlice.actions

export default alternativeProductsSlice.reducer
